// extracted by mini-css-extract-plugin
export default {"page":"styles_page__6DhfO","sessionTime":"styles_sessionTime__JWOmC","layout":"styles_layout__u+E7p"};